@if(data.type === 'add'){
<div class="payment-details">
    <div class="title">
        <span class="title-txt">Add Bank Details</span>
    </div>
    <div class="modal-picture-container">
        @if(file == null){
        <span style="font-size: 16px; color: var(--brand-destructive);">Upload front page of your passbook</span>
        <button class="dp-secondary-btn img-btn" (click)="uploadImg()">Upload</button>
        }@else{
        <img [src]="imagePreview" alt="uploadedImg" style="width: 400px ; height: 150px;">
        <button class="dp-secondary-btn img-btn" (click)="uploadImg()">Retake</button>
        }
    </div>

    <form [formGroup]="bankDetails">
        <div class="details">
            <div class="each-detail">
                <span class="common-title">Account Holder Name</span>
                <input type="text" class="dp-input-control text-inp" placeholder="Enter account holder name"
                    formControlName="accountHolder">
            </div>
            <div class="each-detail">
                <span class="common-title">Account Number</span>
                <input type="text" class="dp-input-control text-inp" placeholder="Enter account number"
                    formControlName="accountNumber" (keydown)="restrictOtpInput($event)">
            </div>
        </div>
        <div class="details">
            <div class="each-detail">
                <span class="common-title">IFSC Code</span>
                <input type="text" class="dp-input-control text-inp" placeholder="Enter IFSC code"
                    formControlName="ifscCode" (input)="getBankDetails($event)" maxlength="11">
            </div>
            <div class="each-detail">
                <span class="common-title">Branch Name</span>
                <input type="text" class="dp-input-control text-inp" placeholder="Enter branch name"
                    formControlName="branchName" readonly>
            </div>
        </div>
        <div class="details">
            <div class="each-detail">
                <span class="common-title">Bank Name</span>
                <input type="text" class="dp-input-control text-inp" placeholder="Enter Bank Name"
                    formControlName="bankName" readonly>
            </div>
        </div>
    </form>

    <div class="btn-div">
        <button class="dp-secondary-btn second-btn" (click)="close()">Close</button>
        <button class="dp-primary-btn second-btn" (click)="submit()">Submit</button>
    </div>

</div>
}@else{
<div class="payment-details">
    <div class="title">
        <span class="title-txt">View Bank Details</span>
    </div>
    <!-- <div class="modal-picture-container">
        @if(demoArr.bankData.url === null){
        <span style="font-size: 16px; color: var(--brand-destructive);">PassBook Image</span>
        }@else{
        <img [src]="imagePreview" alt="uploadedImg" style="width: 400px ; height: 150px;">
        } -->
    <!-- <button class="dp-secondary-btn second-btn">Upload</button> -->
    <!-- </div> -->

    <form [formGroup]="bankDetails">
        <div class="details">
            <div class="each-detail">
                <span class="common-title">Account Holder</span>
                <input type="text" class="dp-input-control text-inp" formControlName='accountHolder' readonly>
            </div>
            <div class="each-detail">
                <span class="common-title">Account Number</span>
                <input type="text" class="dp-input-control text-inp" formControlName="accountNumber" readonly>
            </div>
        </div>
        <div class="details">
            <div class="each-detail">
                <span class="common-title">IFSC Code</span>
                <input type="text" class="dp-input-control text-inp" formControlName="ifscCode" readonly>
            </div>
            <div class="each-detail">
                <span class="common-title">Bank Name</span>
                <input type="text" class="dp-input-control text-inp" formControlName="bankName" readonly>
            </div>
        </div>
        <div class="details">
            <div class="each-detail">
                <span class="common-title">Branch Name</span>
                <input type="text" class="dp-input-control text-inp" formControlName="branchName" readonly>
            </div>
        </div>
    </form>

    <div class="btn-div">
        <button class="dp-secondary-btn second-btn" (click)="close()">Close</button>
        <!-- <button class="dp-primary-btn btn">Submit</button> -->
    </div>

</div>
}